export default __webpack_public_path__ + "static/media/user1.b2471909.png";